import { render, staticRenderFns } from "./SubgroupReports.vue?vue&type=template&id=2cd72328"
import script from "./SubgroupReports.vue?vue&type=script&lang=js"
export * from "./SubgroupReports.vue?vue&type=script&lang=js"
import style0 from "./SubgroupReports.vue?vue&type=style&index=0&id=2cd72328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports